import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

interface OrderTypeItem {
  label: string;
  percent: number;
  value: number;
}

interface OrderTypeCardProps {
  items?: OrderTypeItem[];
}

const defaultItems: OrderTypeItem[] = [
  { label: "Dine-In", percent: 0, value:0 },
  { label: "Takeaway", percent: 0, value:0 },
  { label: "Online", percent: 0, value:0 },
];

export default function OrderTypeCard({ items = defaultItems }: OrderTypeCardProps) {
  const [timeRange, setTimeRange] = useState("Last 9 Months");

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3 sm:p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="m-0 text-base font-semibold text-gray-900 sm:text-lg">Order Type</h3>
        <div className="relative">
          <select
            value={timeRange}
            onChange={(event) => setTimeRange(event.target.value)}
            className="appearance-none rounded-xl border border-gray-200 bg-white py-2 pl-3 pr-9 text-xs text-gray-800 outline-none transition focus:border-gray-400 sm:text-sm"
          >
            <option>This Month</option>
            {/* <option>Last 6 Months</option>
            <option>Last 9 Months</option>
            <option>Last 12 Months</option> */}
          </select>
          <ChevronDown
            size={16}
            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
          />
        </div>
      </div>

      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
            {/* Icon */}
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gray-100 text-lg sm:h-12 sm:w-12 sm:rounded-2xl sm:text-xl">
              ☕
            </div>

            {/* Label + bar + value */}
            <div className="flex flex-1 items-center gap-3">
              {/* Left: label row + bar below */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <p className="m-0 text-base font-semibold text-gray-900 sm:text-lg">{item.label}</p>
                  <p className="m-0 text-xs text-gray-500 sm:text-sm">{item.percent}%</p>
                </div>
                {/* Bar sits directly under the text */}
                <div className="h-1 w-full rounded-full bg-gray-200">
                  <div
                    className="h-1 rounded-full bg-blue-600"
                    style={{
                      width: `${Math.max(Math.min(item.percent, 100), 0)}%`,
                    }}
                  />
                </div>
              </div>

              {/* Right: value */}
              <p className="m-0 shrink-0 text-sm font-bold text-gray-900 sm:text-base">{item.value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* <div className="mt-3 text-right">
        <button className="text-sm text-gray-900 underline underline-offset-4">
          view all reports
        </button>
      </div> */}
    </div>
  );
}
